export enum DeckSource {
    Unknown,
    Moxfield,
    Archidekt
}
